import { render, staticRenderFns } from "./SettlementManagement.vue?vue&type=template&id=3517d476&scoped=true"
import script from "./SettlementManagement.vue?vue&type=script&lang=js"
export * from "./SettlementManagement.vue?vue&type=script&lang=js"
import style0 from "./SettlementManagement.vue?vue&type=style&index=0&id=3517d476&prod&lang=less"
import style1 from "./SettlementManagement.vue?vue&type=style&index=1&id=3517d476&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3517d476",
  null
  
)

export default component.exports